import React from 'react';
import { useFormik } from 'formik';

import { formFields } from '../constants';
import { FormGrid, OptionsButton, generateSchema } from '../components/common';

import { generateField } from './generateField';
import { FIELD_TYPE } from './CONSTANT';

export const useFormGenerator = (
  { schema = [ {
    id: formFields.GLN,
    initial: undefined,
    label: 'gln label default column',
    disabled: false,
    onChange: value => {},
    fieldType: FIELD_TYPE.STRING
  }, {
    id: `${formFields.GLN}_Required`,
    initial: true,
    hidden: true

  } ],
  onSubmit = values => { console.log({ values }); },
  overrideValidationSchema = {}
  }
) => {

  /**
   * Generates a form generator function that initializes Formik with provided schema and validation.
   *
   * @param {Object} options - The options object for configuring the form generator.
   * @param {Array} options.schema - The schema array defining form fields with properties like id, initial value,
   * label, and disabled status.
   * @param {Function} options.onSubmit - The function to handle form submission with values as input.
   * @param {Object} options.overrideValidationSchema - The optional override for validation schema.
   * @returns {Object} An object containing Formik instance, form fields, and a FormGrid component with action buttons.
   */
  const initialValues = schema.reduce((p, c) => ({ ...p, [c.id]: c.initial }), {});
  const fieldIds = schema.map(i => i.id);

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema: generateSchema(fieldIds, overrideValidationSchema)
  });

  const fields = schema
    .filter(i => !i.hidden)
    .map(i => generateField({
      formik,
      ...i
    }));


  return {
    formik,
    fields,
    Component: <FormGrid
      fields={ fields }
      actionComponent={ <OptionsButton onSubmit={ formik.handleSubmit } /> }
               />
  };


};
